import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LiapiService } from '../service/liapi.service';
import { ResourceService } from '../service/resource.service';
import $ from 'jquery';
import { finalize } from 'rxjs';
import { UserService } from '../service/user.service';

@Component({
  selector: 'addressverification-api',
  templateUrl: './addressverificationapi.component.html'
})
export class AddressverificationApiComponent implements OnInit {
  public vmaParamLink = '';
  public vmaproParamLink = '';
  public vmapreParamLink = '';
  public vmauscanParamLink = '';
  public cspParamLink = '';
  public gpcParamLink = '';
  public addressLine1 = '1700 District Ave #300';
  public addressLine2 = '';
  public city = 'Burlington';
  public stateProvince = 'MA';
  public postalCode = '01803';
  public country = 'USA';
  public firmName = 'Precisely';
  public dataType = 'json';
  public outputCasing = 'M';
  public addressLine1Pro = '1700 District Ave #300';
  public addressLine2Pro = '';
  public cityPro = 'Burlington';
  public stateProvincePro = 'MA';
  public postalCodePro = '01803';
  public countryPro = 'USA';
  public firmNamePro = 'Precisely';
  public dataTypePro = 'json';
  public outputCasingPro = 'M';
  public maximumResultsPro = '10';
  public keepMultimatchPro = 'N';
  public outputScriptPro = 'InputScript';
  public outputAddressBlocksPro = 'Y';
  public outputCountryFormatPro = 'E';
  public addressLine1Pre = '1700 District Ave #300';
  public addressLine2Pre = '';
  public addressLine3Pre = '';
  public addressLine4Pre = '';
  public addressLine5Pre = '';
  public cityPre = 'Burlington';
  public stateProvincePre = 'MA';
  public postalCodePre = '01803';
  public countryPre = 'USA';
  public firmNamePre = 'Precisely';
  public dataTypePre = 'json';
  public outputCasingPre = 'M';
  public maximumResultsPre = '10';
  public keepMultimatchPre = 'N';
  public outputScriptPre = 'InputScript';
  public outputAddressBlocksPre = 'Y';
  public outputCountryFormatPre = 'E';
  public outputFieldLevelReturnCodesPre = 'N';
  public outputRecordTypePre = 'A';
  public addressLine1USCan = '1700 District Ave #300';
  public addressLine2USCan = '';
  public addressLine3USCan = '';
  public addressLine4USCan = '';
  public cityUSCan = 'Burlington';
  public stateProvinceUSCan = 'MA';
  public postalCodeUSCan = '01803';
  public countryUSCan = 'USA';
  public firmNameUSCan = 'Precisely';
  public canLanguageUSCan = '';
  public USUrbanNameUSCan = '';
  public dataTypeUSCan = 'json';
  public outputCasingUSCan = 'M';
  public performUSProcessingUSCan = 'Y';
  public performDPVUSCan = 'N';
  public outputFormattedOnFailUSCan = 'N';
  public outputPostalCodeSeparatorUSCan = 'Y';
  public outputStreetNameAliasUSCan = 'Y';
  public outputAddressBlocksUSCan = 'Y';
  public keepMultimatchUSCan = 'N';
  public outputCountryFormatUSCan = 'E';
  public maximumResultsUSCan = '10';
  public outputFieldLevelReturnCodesUSCan = 'N';
  public outputRecordTypeUSCan = 'A';
  public outputMultinationalCharactersUSCan = 'N';
  public standardAddressFormatUSCan = 'C';
  public outputShortCityNameUSCan = 'N';
  public dualAddressLogicUSCan = 'N';
  public performLACSLinkUSCan = 'Y';
  public performEWSUSCan = 'N';
  public extractFirmUSCan = 'N';
  public extractUrbUSCan = 'N';
  public performSuiteLinkUSCan = 'N';
  public outputPreferredAliasUSCan = 'N';
  public outputAbbreviatedAliasUSCan = 'N';
  public dPVDetermineNoStatUSCan = 'N';
  public dPVDetermineVacancyUSCan = 'N';
  public suppressZplusPhantomCarrierR777USCan = 'N';
  public streetMatchingStrictnessUSCan = 'M';
  public firmMatchingStrictnessUSCan = 'M';
  public directionalMatchingStrictnessUSCan = 'M';
  public dPVSuccessfulStatusConditionUSCan = 'A';
  public failOnCMRAMatchUSCan = 'N';
  public standardAddressPMBLineUSCan = 'N';
  public outputPreferredCityUSCan = 'Z';
  public canFrenchFormatUSCan = 'C';
  public canEnglishApartmentLabelUSCan = 'Apt';
  public canFrenchApartmentLabelUSCan = 'App';
  public canSSLVRFlgUSCan = 'N';
  public canPreferHouseNumUSCan = 'N';
  public canOutputCityAliasUSCan = 'Y';
  public canNonCivicFormatUSCan = 'A';
  public canStandardAddressFormatUSCan = 'D';
  public canOutputCityFormatUSCan = 'D';
  public canRuralRouteFormatUSCan = 'A';
  public canDeliveryOfficeFormatUSCan = 'I';
  public canDualAddressLogicUSCan = 'D';
  public postalCodeGetCityStateProvince = '01803';
  public dataTypeGetCityStateProvince = 'json';
  public performUSProcessing = 'Y';
  public performCanadianProcessing = 'Y';
  public outputVanityCity = 'N';
  public maximumResultsGetCityStateProvince = '10';
  public cityGetPostalCodes = 'Burlington';
  public stateProvinceGetPostalCodes = 'MA';
  public dataTypeGetPostalCodes = 'json';
  public outputVanityCity_PostalCodes = 'N';
  public outputCityType = 'N';
  public showpage: boolean = false;
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private liapiservice: LiapiService, private resourceService: ResourceService, private metaTagService: Meta, private userService: UserService) { };

  ngOnInit() {
    window.scroll(0, 0);
    this.metaTagService.updateTag(
      { name: 'keywords', content: 'precisely api, us address validation api, address validation api, address validator api, address verification api, address standardization api, global address verification api, address verification, verify mailing address, address api, validate mailing address, how to verify a mailing address, canada address verification, canadian address verification, mailing address validation, address validation canada, mailing address verification, physical mail api, address check, usps address validation api, usps address verification api, location verification, postal data match, postal, address correction, address parsing, deliverability, mailability' }
    );
    let docsURL = JSON.parse(`[{"val": "${localStorage.getItem("docsURL")}"}]`)[0].val;
    if(docsURL == "null"){
      this.resourceService.getDocsUrl().subscribe(
        success => {
          this.setParamLink(success.docsURL);
        }
      );
    }
    else{
      this.setParamLink(docsURL);
    }
    this.userService.getUserDeatails().subscribe(
      _success => {
        this.showpage = true;
      },
      _error => {
        window.location.href = "/pricing";
      }
    );
  };
  setParamLink = function (docsURL) {
    this.vmaParamLink = docsURL + 'AddressVerification/Validate_Mailing_Address/query_params.html';
    this.vmaproParamLink = docsURL + 'AddressVerification/Validate_Mailing_Address_Pro/query_params.html';
    this.vmapreParamLink = docsURL + 'AddressVerification/Validate_Mailing_Address_Premium/query_params.html';
    this.vmauscanParamLink = docsURL + 'AddressVerification/Validate_Mailing_Address_USCAN/query_params.html';
    this.cspParamLink = docsURL + 'AddressVerification/Get_City_State_Province/query_params.html';
    this.gpcParamLink = docsURL + 'AddressVerification/Get_Postal_Codes/query_params.html';
  };
  clearResult = function (result) {
    switch (result) {
      case 'post_addrRes':
        this.post_addrUri = "";
        this.post_addrBody = null;
        this.post_addrRes = null;
        this.post_addrResStatus = "";
        this.post_addrResType = "";
        break;
      case 'post_addrProRes':
        this.post_addrProUri = "";
        this.post_addrProBody = null;
        this.post_addrProRes = null;
        this.post_addrProResStatus = "";
        this.post_addrProResType = "";
        break;
      case 'post_addrPreRes':
        this.post_addrPreUri = "";
        this.post_addrPreBody = null;
        this.post_addrPreRes = null;
        this.post_addrPreResStatus = "";
        this.post_addrPreResType = "";
        break;
      case 'post_addrUsCanRes':
        this.post_addrUsCanUri = "";
        this.post_addrUsCanBody = null;
        this.post_addrUsCanRes = null;
        this.post_addrUsCanResStatus = "";
        this.post_addrUsCanResType = "";
        break;
      case 'post_cityStateRes':
        this.post_cityStateUri = "";
        this.post_cityStateBody = null;
        this.post_cityStateRes = null;
        this.post_cityStateResStatus = "";
        this.post_cityStateResType = "";
        break;
      case 'post_postalRes':
        this.post_postalUri = "";
        this.post_postalBody = null;
        this.post_postalRes = null;
        this.post_postalResStatus = "";
        this.post_postalResType = "";
        break;
    }
  };
  toogleOptionalContainer = function (optConHan, optCon) {
    var domEle = $('#' + optConHan);
    var domEleNext = $('#' + optCon);
    if (domEleNext.prop('style')['display'] == 'none') {
      domEleNext.show(200);
      domEle.removeClass('plus');
      domEle.addClass('minus');
    }
    else {
      domEleNext.hide(200);
      domEle.removeClass('minus');
      domEle.addClass('plus');
    }
  };
  public post_addrUri = "";
  public post_addrBody = null;
  public post_addrRes = null;
  public post_addrResStatus = "";
  public post_addrResType = "";
  tryApiValidateMailingAddress = function (btnId) {
    var addressLine1 = this.addressLine1;
    var addressLine2 = this.addressLine2;
    var city = this.city;
    var stateProvince = this.stateProvince;
    var postalCode = this.postalCode;
    var country = this.country;
    var firmName = this.firmName;
    var dataType = this.dataType;
    var outputCasing = this.outputCasing;
    var requestAddress;
    if (dataType == 'json') {
      requestAddress = '{"options": { "OutputCasing":"' + outputCasing + '" }, "Input": {"Row": [{' + '"AddressLine1": "' + addressLine1 + '",' + '"AddressLine2": "' + addressLine2 + '",' + '"City": "' + city + '",' + '"Country": "' + country + '",' + '"StateProvince": "' + stateProvince + '",' + '"PostalCode": "' + postalCode + '",' + '"FirmName": "' + firmName + '"}]}}';
    }
    else {
      requestAddress = '<ValidateMailingAddressAPIRequest><options><OutputCasing>' + outputCasing + '</OutputCasing></options><Input><Row><AddressLine1>' + addressLine1 + '</AddressLine1><AddressLine2>' + addressLine2 + '</AddressLine2><City>' + city + '</City><Country>' + country + '</Country><StateProvince>' + stateProvince + '</StateProvince><PostalCode>' + postalCode + '</PostalCode><FirmName>' + firmName + '</FirmName></Row></Input></ValidateMailingAddressAPIRequest>';
    }
    var tmpData = {
      dataType: dataType,
      data: requestAddress,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      city: city,
      country: country,
      stateProvince: stateProvince,
      postalCode: postalCode,
      firmName: firmName,
      outputCasing: outputCasing
    };
    var methodName = '/tryApiValidateMailingAddressRest';
    let requestUri = this.liapiservice.getCompleteUriPostLikeGet('addressverification', 'ValidateMailingAddress', dataType);
    this.liapiservice.disableTryItBtn(btnId);
    this.liapiservice.geoAPIsTryApiBatchLikeGetCall(methodName, tmpData).pipe(
      finalize(() => {
        this.liapiservice.enableTryItBtn(btnId);
        this.post_addrUri = requestUri;
        this.post_addrResType = dataType;
        this.post_addrBody = this.liapiservice.getFormattedResponse(dataType, requestAddress);
        if(this.post_addrResStatus.includes('429')){
          this.post_addrUri = '';
          this.liapiservice.showPrimeInfo();
        }
      }
    )).subscribe(
      success => {
        this.post_addrResStatus = '200 success';
        this.post_addrRes = this.liapiservice.getFormattedResponse(dataType, success);
      },
      error => {
        if (error.status && error.statusText) {
          this.post_addrResStatus = `${error.status} ${error.statusText}`;
          this.post_addrRes = this.liapiservice.getFormattedResponse(dataType, error.error);
        }
      }
    );
  };
  public post_addrProUri = "";
  public post_addrProBody = null;
  public post_addrProRes = null;
  public post_addrProResStatus = "";
  public post_addrProResType = "";
  tryApiValidateMailingAddressPro = function (btnId) {
    var addressLine1 = this.addressLine1Pro;
    var addressLine2 = this.addressLine2Pro;
    var city = this.cityPro;
    var country = this.countryPro;
    var stateProvince = this.stateProvincePro;
    var postalCode = this.postalCodePro;
    var firmName = this.firmNamePro;
    var dataType = this.dataTypePro;
    var outputCasing = this.outputCasingPro;
    var maximumResults = this.maximumResultsPro;
    var keepMultimatch = this.keepMultimatchPro;
    var outputScript = this.outputScriptPro;
    var outputAddressBlocks = this.outputAddressBlocksPro;
    var outputCountryFormat = this.outputCountryFormatPro;
    var requestAddress;
    if (dataType == 'json') {
      requestAddress = '{"options": {"OutputCasing": "' + outputCasing + '","MaximumResults":"' + maximumResults + '", "KeepMultimatch":"' + keepMultimatch + '","OutputScript":"' + outputScript + '","OutputAddressBlocks":"' + outputAddressBlocks + '","OutputCountryFormat":"' + outputCountryFormat + '"},' + '"Input": {"Row": [{ ' + '"AddressLine1": "' + addressLine1 + '",' + '"AddressLine2": "' + addressLine2 + '",' + '"City": "' + city + '",' + '"Country": "' + country + '",' + '"StateProvince": "' + stateProvince + '",' + '"PostalCode": "' + postalCode + '",' + '"FirmName": "' + firmName + '"}]}}';
    }
    else {
      requestAddress = '<ValidateMailingAddressProAPIRequest><options><OutputCasing>' + outputCasing + '</OutputCasing><KeepMultimatch>' + keepMultimatch + '</KeepMultimatch><OutputCountryFormat>' + outputCountryFormat + '</OutputCountryFormat><MaximumResults>' + maximumResults + '</MaximumResults><OutputScript>' + outputScript + '</OutputScript><OutputAddressBlocks>' + outputAddressBlocks + '</OutputAddressBlocks></options><Input><Row><AddressLine1>' + addressLine1 + '</AddressLine1><AddressLine2>' + addressLine2 + '</AddressLine2><City>' + city + '</City><Country>' + country + '</Country><StateProvince>' + stateProvince + '</StateProvince><PostalCode>' + postalCode + '</PostalCode><FirmName>' + firmName + '</FirmName></Row></Input></ValidateMailingAddressProAPIRequest>';
    }
    var tmpData = {
      dataType: dataType,
      data: requestAddress,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      city: city,
      country: country,
      stateProvince: stateProvince,
      postalCode: postalCode,
      firmName: firmName,
      outputCasing: outputCasing
    };
    var methodName = '/tryApiValidateMailingAddressProRest';
    let requestUri = this.liapiservice.getCompleteUriPostLikeGet('addressverification', 'ValidateMailingAddressPro', dataType);
    this.liapiservice.disableTryItBtn(btnId);
    this.liapiservice.geoAPIsTryApiBatchLikeGetCall(methodName, tmpData).pipe(
      finalize(() => {
        this.liapiservice.enableTryItBtn(btnId);
        this.post_addrProUri = requestUri;
        this.post_addrProResType = dataType;
        this.post_addrProBody = this.liapiservice.getFormattedResponse(dataType, requestAddress);
        if(this.post_addrProResStatus.includes('429')){
          this.post_addrProUri = '';
          this.liapiservice.showPrimeInfo();
        }
      }
    )).subscribe(
      success => {
        this.post_addrProResStatus = '200 success';
        this.post_addrProRes = this.liapiservice.getFormattedResponse(dataType, success);
      },
      error => {
        if (error.status && error.statusText) {
          this.post_addrProResStatus = `${error.status} ${error.statusText}`;
          this.post_addrProRes = this.liapiservice.getFormattedResponse(dataType, error.error);
        }
      }
    );
  };
  public post_addrPreUri = "";
  public post_addrPreBody = null;
  public post_addrPreRes = null;
  public post_addrPreResStatus = "";
  public post_addrPreResType = "";
  tryApiValidateMailingAddressPremium = function (btnId) {
    var addressLine1 = this.addressLine1Pre;
    var addressLine2 = this.addressLine2Pre;
    var addressLine3 = this.addressLine3Pre;
    var addressLine4 = this.addressLine4Pre;
    var addressLine5 = this.addressLine5Pre;
    var city = this.cityPre;
    var country = this.countryPre;
    var stateProvince = this.stateProvincePre;
    var postalCode = this.postalCodePre;
    var firmName = this.firmNamePre;
    var dataType = this.dataTypePre;
    var outputCasing = this.outputCasingPre;
    var maximumResults = this.maximumResultsPre;
    var keepMultimatch = this.keepMultimatchPre;
    var outputScript = this.outputScriptPre;
    var outputAddressBlocks = this.outputAddressBlocksPre;
    var outputCountryFormat = this.outputCountryFormatPre;
    var outputFieldLevelReturnCodes = this.outputFieldLevelReturnCodesPre;
    var outputRecordType = this.outputRecordTypePre;
    var requestAddress;
    if (dataType == 'json') {
      requestAddress = '{"options": {"OutputCasing": "' + outputCasing + '","MaximumResults":"' + maximumResults + '","KeepMultimatch":"' + keepMultimatch + '","OutputScript":"' + outputScript + '","OutputAddressBlocks":"' + outputAddressBlocks + '","OutputCountryFormat":"' + outputCountryFormat + '","OutputFieldLevelReturnCodes":"' + outputFieldLevelReturnCodes + '", "OutputRecordType":"' + outputRecordType + '"},' + '"Input": {"Row": [{' + '"AddressLine1": "' + addressLine1 + '",' + '"AddressLine2": "' + addressLine2 + '",' + '"AddressLine3": "' + addressLine3 + '",' + '"AddressLine4": "' + addressLine4 + '",' + '"AddressLine5": "' + addressLine5 + '",' + '"City": "' + city + '",' + '"Country": "' + country + '",' + '"StateProvince": "' + stateProvince + '",' + '"PostalCode": "' + postalCode + '",' + '"FirmName": "' + firmName + '"}]}}';
    }
    else {
      requestAddress = '<ValidateMailingAddressPremiumAPIRequest><options><OutputCasing>' + outputCasing + '</OutputCasing><KeepMultimatch>' + keepMultimatch + '</KeepMultimatch><OutputCountryFormat>' + outputCountryFormat + '</OutputCountryFormat><MaximumResults>' + maximumResults + '</MaximumResults><OutputScript>' + outputScript + '</OutputScript><OutputAddressBlocks>' + outputAddressBlocks + '</OutputAddressBlocks><OutputFieldLevelReturnCodes>' + outputFieldLevelReturnCodes + '</OutputFieldLevelReturnCodes><OutputRecordType>' + outputRecordType + '</OutputRecordType></options><Input><Row><AddressLine1>' + addressLine1 + '</AddressLine1><AddressLine2>' + addressLine2 + '</AddressLine2><AddressLine3>' + addressLine3 + '</AddressLine3><AddressLine4>' + addressLine4 + '</AddressLine4><AddressLine5>' + addressLine5 + '</AddressLine5><City>' + city + '</City><Country>' + country + '</Country><StateProvince>' + stateProvince + '</StateProvince><PostalCode>' + postalCode + '</PostalCode><FirmName>' + firmName + '</FirmName></Row></Input></ValidateMailingAddressPremiumAPIRequest>';
    }
    var tmpData = {
      dataType: dataType,
      data: requestAddress,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      city: city,
      country: country,
      stateProvince: stateProvince,
      postalCode: postalCode,
      firmName: firmName,
      outputCasing: outputCasing
    };
    var methodName = '/tryApiValidateMailingAddressPremiumRest';
    let requestUri = this.liapiservice.getCompleteUriPostLikeGet('addressverification', 'ValidateMailingAddressPremium', dataType);
    this.liapiservice.disableTryItBtn(btnId);
    this.liapiservice.geoAPIsTryApiBatchLikeGetCall(methodName, tmpData).pipe(
      finalize(() => {
        this.liapiservice.enableTryItBtn(btnId);
        this.post_addrPreUri = requestUri;
        this.post_addrPreResType = dataType;
        this.post_addrPreBody = this.liapiservice.getFormattedResponse(dataType, requestAddress);
        if(this.post_addrPreResStatus.includes('429')){
          this.post_addrPreUri = '';
          this.liapiservice.showPrimeInfo();
        }
      }
    )).subscribe(
      success => {
        this.post_addrPreResStatus = '200 success';
        this.post_addrPreRes = this.liapiservice.getFormattedResponse(dataType, success);
      },
      error => {
        if (error.status && error.statusText) {
          this.post_addrPreResStatus = `${error.status} ${error.statusText}`;
          this.post_addrPreRes = this.liapiservice.getFormattedResponse(dataType, error.error);
        }
      }
    );
  };
  public post_addrUsCanUri = "";
  public post_addrUsCanBody = null;
  public post_addrUsCanRes = null;
  public post_addrUsCanResStatus = "";
  public post_addrUsCanResType = "";
  tryApiValidateMailingAddressUSCan = function (btnId) {
    var addressLine1 = this.addressLine1USCan;
    var addressLine2 = this.addressLine2USCan;
    var addressLine3 = this.addressLine3USCan;
    var addressLine4 = this.addressLine4USCan;
    var city = this.cityUSCan;
    var stateProvince = this.stateProvinceUSCan;
    var postalCode = this.postalCodeUSCan;
    var country = this.countryUSCan;
    var firmName = this.firmNameUSCan;
    var canLanguage = this.canLanguageUSCan;
    var usUrbanName = this.USUrbanNameUSCan;
    var dataType = this.dataTypeUSCan;
    var outputCasing = this.outputCasingUSCan;
    var performUSProcessing = this.performUSProcessingUSCan;
    var performDPV = this.performDPVUSCan;
    var outputPostalCodeSeparator = this.outputPostalCodeSeparatorUSCan;
    var outputFormattedOnFail = this.outputFormattedOnFailUSCan;
    var outputStreetNameAliasUSCan = this.outputStreetNameAliasUSCan;
    var outputAddressBlocksUSCan = this.outputAddressBlocksUSCan;
    var keepMultimatchUSCan = this.keepMultimatchUSCan;
    var outputCountryFormatUSCan = this.outputCountryFormatUSCan;
    var maximumResultsUSCan = this.maximumResultsUSCan;
    var outputFieldLevelReturnCodesUSCan = this.outputFieldLevelReturnCodesUSCan;
    var outputRecordTypeUSCan = this.outputRecordTypeUSCan;
    var outputMultinationalCharactersUSCan = this.outputMultinationalCharactersUSCan;
    var standardAddressFormatUSCan = this.standardAddressFormatUSCan;
    var outputShortCityNameUSCan = this.outputShortCityNameUSCan;
    var dualAddressLogicUSCan = this.dualAddressLogicUSCan;
    var performLACSLinkUSCan = this.performLACSLinkUSCan;
    var performEWSUSCan = this.performEWSUSCan;
    var extractFirmUSCan = this.extractFirmUSCan;
    var extractUrbUSCan = this.extractUrbUSCan;
    var performSuiteLinkUSCan = this.performSuiteLinkUSCan;
    var outputPreferredAliasUSCan = this.outputPreferredAliasUSCan;
    var outputAbbreviatedAliasUSCan = this.outputAbbreviatedAliasUSCan;
    var dPVDetermineNoStatUSCan = this.dPVDetermineNoStatUSCan;
    var dPVDetermineVacancyUSCan = this.dPVDetermineVacancyUSCan;
    var suppressZplusPhantomCarrierR777USCan = this.suppressZplusPhantomCarrierR777USCan;
    var streetMatchingStrictnessUSCan = this.streetMatchingStrictnessUSCan;
    var firmMatchingStrictnessUSCan = this.firmMatchingStrictnessUSCan;
    var directionalMatchingStrictnessUSCan = this.directionalMatchingStrictnessUSCan;
    var dPVSuccessfulStatusConditionUSCan = this.dPVSuccessfulStatusConditionUSCan;
    var failOnCMRAMatchUSCan = this.failOnCMRAMatchUSCan;
    var standardAddressPMBLineUSCan = this.standardAddressPMBLineUSCan;
    var outputPreferredCityUSCan = this.outputPreferredCityUSCan;
    var canFrenchFormatUSCan = this.canFrenchFormatUSCan;
    var canEnglishApartmentLabelUSCan = this.canEnglishApartmentLabelUSCan;
    var canFrenchApartmentLabelUSCan = this.canFrenchApartmentLabelUSCan;
    var canSSLVRFlgUSCan = this.canSSLVRFlgUSCan;
    var canPreferHouseNumUSCan = this.canPreferHouseNumUSCan;
    var canOutputCityAliasUSCan = this.canOutputCityAliasUSCan;
    var canNonCivicFormatUSCan = this.canNonCivicFormatUSCan;
    var canStandardAddressFormatUSCan = this.canStandardAddressFormatUSCan;
    var canOutputCityFormatUSCan = this.canOutputCityFormatUSCan;
    var canRuralRouteFormatUSCan = this.canRuralRouteFormatUSCan;
    var canDeliveryOfficeFormatUSCan = this.canDeliveryOfficeFormatUSCan;
    var canDualAddressLogicUSCan = this.canDualAddressLogicUSCan;
    var requestAddress;
    if (dataType == 'json') {
      requestAddress = '{"options": { "OutputCasing":"' + outputCasing + '",' + '"PerformUSProcessing": "' + performUSProcessing + '",' + '"PerformDPV": "' + performDPV + '",' + '"OutputFormattedOnFail": "' + outputFormattedOnFail + '",' + '"OutputPostalCodeSeparator": "' + outputPostalCodeSeparator + '",' + '"OutputStreetNameAlias": "' + outputStreetNameAliasUSCan + '",' + '"OutputAddressBlocks": "' + outputAddressBlocksUSCan + '",' + '"KeepMultimatch": "' + keepMultimatchUSCan + '",' + '"OutputCountryFormat": "' + outputCountryFormatUSCan + '",' + '"MaximumResults": "' + maximumResultsUSCan + '",' + '"OutputFieldLevelReturnCodes": "' + outputFieldLevelReturnCodesUSCan + '",' + '"OutputRecordType": "' + outputRecordTypeUSCan + '",' + '"OutputMultinationalCharacters": "' + outputMultinationalCharactersUSCan + '",' + '"StandardAddressFormat": "' + standardAddressFormatUSCan + '",' + '"OutputShortCityName": "' + outputShortCityNameUSCan + '",' + '"DualAddressLogic": "' + dualAddressLogicUSCan + '",' + '"PerformLACSLink": "' + performLACSLinkUSCan + '",' + '"PerformEWS": "' + performEWSUSCan + '",' + '"ExtractFirm": "' + extractFirmUSCan + '",' + '"ExtractUrb": "' + extractUrbUSCan + '",' + '"PerformSuiteLink": "' + performSuiteLinkUSCan + '",' + '"OutputPreferredAlias": "' + outputPreferredAliasUSCan + '",' + '"OutputAbbreviatedAlias": "' + outputAbbreviatedAliasUSCan + '",' + '"DPVDetermineNoStat": "' + dPVDetermineNoStatUSCan + '",' + '"DPVDetermineVacancy": "' + dPVDetermineVacancyUSCan + '",' + '"SuppressZplusPhantomCarrierR777": "' + suppressZplusPhantomCarrierR777USCan + '",' + '"StreetMatchingStrictness": "' + streetMatchingStrictnessUSCan + '",' + '"FirmMatchingStrictness": "' + firmMatchingStrictnessUSCan + '",' + '"DirectionalMatchingStrictness": "' + directionalMatchingStrictnessUSCan + '",' + '"DPVSuccessfulStatusCondition": "' + dPVSuccessfulStatusConditionUSCan + '",' + '"FailOnCMRAMatch": "' + failOnCMRAMatchUSCan + '",' + '"StandardAddressPMBLine": "' + standardAddressPMBLineUSCan + '",' + '"OutputPreferredCity": "' + outputPreferredCityUSCan + '",' + '"CanFrenchFormat": "' + canFrenchFormatUSCan + '",' + '"CanEnglishApartmentLabel": "' + canEnglishApartmentLabelUSCan + '",' + '"CanFrenchApartmentLabel": "' + canFrenchApartmentLabelUSCan + '",' + '"CanSSLVRFlg": "' + canSSLVRFlgUSCan + '",' + '"CanPreferHouseNum": "' + canPreferHouseNumUSCan + '",' + '"CanOutputCityAlias": "' + canOutputCityAliasUSCan + '",' + '"CanNonCivicFormat": "' + canNonCivicFormatUSCan + '",' + '"CanStandardAddressFormat": "' + canStandardAddressFormatUSCan + '",' + '"CanOutputCityFormat": "' + canOutputCityFormatUSCan + '",' + '"CanRuralRouteFormat": "' + canRuralRouteFormatUSCan + '",' + '"CanDeliveryOfficeFormat": "' + canDeliveryOfficeFormatUSCan + '",' + '"CanDualAddressLogic": "' + canDualAddressLogicUSCan + '" },"Input": {"Row": [  { ' + '"AddressLine1": "' + addressLine1 + '",' + '"AddressLine2": "' + addressLine2 + '",' + '"AddressLine3": "' + addressLine3 + '",' + '"AddressLine4": "' + addressLine4 + '",' + '"City": "' + city + '",' + '"Country": "' + country + '",' + '"StateProvince": "' + stateProvince + '",' + '"PostalCode": "' + postalCode + '",' + '"FirmName": "' + firmName + '",' + '"USUrbanName": "' + usUrbanName + '",' + '"CanLanguage": "' + canLanguage + '"}]}}';
    }
    else {
      requestAddress = '<ValidateMailingAddressUSCANAPIRequest><options><OutputCasing>' + outputCasing + '</OutputCasing><PerformUSProcessing>' + performUSProcessing + '</PerformUSProcessing><PerformDPV>' + performDPV + '</PerformDPV><OutputFormattedOnFail>' + outputFormattedOnFail + '</OutputFormattedOnFail><OutputPostalCodeSeparator>' + outputPostalCodeSeparator + '</OutputPostalCodeSeparator><OutputStreetNameAlias>' + outputStreetNameAliasUSCan + '</OutputStreetNameAlias><OutputAddressBlocks>' + outputAddressBlocksUSCan + '</OutputAddressBlocks><KeepMultimatch>' + keepMultimatchUSCan + '</KeepMultimatch><OutputCountryFormat>' + outputCountryFormatUSCan + '</OutputCountryFormat><MaximumResults>' + maximumResultsUSCan + '</MaximumResults><OutputFieldLevelReturnCodes>' + outputFieldLevelReturnCodesUSCan + '</OutputFieldLevelReturnCodes><OutputRecordType>' + outputRecordTypeUSCan + '</OutputRecordType><OutputMultinationalCharacters>' + outputMultinationalCharactersUSCan + '</OutputMultinationalCharacters><StandardAddressFormat>' + standardAddressFormatUSCan + '</StandardAddressFormat><OutputShortCityName>' + outputShortCityNameUSCan + '</OutputShortCityName><DualAddressLogic>' + dualAddressLogicUSCan + '</DualAddressLogic><PerformLACSLink>' + performLACSLinkUSCan + '</PerformLACSLink><PerformEWS>' + performEWSUSCan + '</PerformEWS><ExtractFirm>' + extractFirmUSCan + '</ExtractFirm><ExtractUrb>' + extractUrbUSCan + '</ExtractUrb><PerformSuiteLink>' + performSuiteLinkUSCan + '</PerformSuiteLink><OutputPreferredAlias>' + outputPreferredAliasUSCan + '</OutputPreferredAlias><OutputAbbreviatedAlias>' + outputAbbreviatedAliasUSCan + '</OutputAbbreviatedAlias><DPVDetermineNoStat>' + dPVDetermineNoStatUSCan + '</DPVDetermineNoStat><DPVDetermineVacancy>' + dPVDetermineVacancyUSCan + '</DPVDetermineVacancy><SuppressZplusPhantomCarrierR777>' + suppressZplusPhantomCarrierR777USCan + '</SuppressZplusPhantomCarrierR777><StreetMatchingStrictness>' + streetMatchingStrictnessUSCan + '</StreetMatchingStrictness><FirmMatchingStrictness>' + firmMatchingStrictnessUSCan + '</FirmMatchingStrictness><DirectionalMatchingStrictness>' + directionalMatchingStrictnessUSCan + '</DirectionalMatchingStrictness><DPVSuccessfulStatusCondition>' + dPVSuccessfulStatusConditionUSCan + '</DPVSuccessfulStatusCondition><FailOnCMRAMatch>' + failOnCMRAMatchUSCan + '</FailOnCMRAMatch><StandardAddressPMBLine>' + standardAddressPMBLineUSCan + '</StandardAddressPMBLine><OutputPreferredCity>' + outputPreferredCityUSCan + '</OutputPreferredCity><CanFrenchFormat>' + canFrenchFormatUSCan + '</CanFrenchFormat><CanEnglishApartmentLabel>' + canEnglishApartmentLabelUSCan + '</CanEnglishApartmentLabel><CanFrenchApartmentLabel>' + canFrenchApartmentLabelUSCan + '</CanFrenchApartmentLabel><CanSSLVRFlg>' + canSSLVRFlgUSCan + '</CanSSLVRFlg><CanPreferHouseNum>' + canPreferHouseNumUSCan + '</CanPreferHouseNum><CanOutputCityAlias>' + canOutputCityAliasUSCan + '</CanOutputCityAlias><CanNonCivicFormat>' + canNonCivicFormatUSCan + '</CanNonCivicFormat><CanStandardAddressFormat>' + canStandardAddressFormatUSCan + '</CanStandardAddressFormat><CanOutputCityFormat>' + canOutputCityFormatUSCan + '</CanOutputCityFormat><CanRuralRouteFormat>' + canRuralRouteFormatUSCan + '</CanRuralRouteFormat><CanDeliveryOfficeFormat>' + canDeliveryOfficeFormatUSCan + '</CanDeliveryOfficeFormat><CanDualAddressLogic>' + canDualAddressLogicUSCan + '</CanDualAddressLogic></options><Input><Row><AddressLine1>' + addressLine1 + '</AddressLine1><AddressLine2>' + addressLine2 + '</AddressLine2><AddressLine3>' + addressLine3 + '</AddressLine3><AddressLine4>' + addressLine4 + '</AddressLine4><City>' + city + '</City><Country>' + country + '</Country><StateProvince>' + stateProvince + '</StateProvince><PostalCode>' + postalCode + '</PostalCode><USUrbanName>' + usUrbanName + '</USUrbanName><FirmName>' + firmName + '</FirmName><CanLanguage>' + canLanguage + '</CanLanguage></Row></Input></ValidateMailingAddressUSCANAPIRequest>';
    }
    var tmpData = {
      dataType: dataType,
      data: requestAddress
    };
    var methodName = '/tryApiValidateMailingAddressUSCANRest';
    let requestUri = this.liapiservice.getCompleteUriPostLikeGet('addressverification', 'ValidateMailingAddressUSCAN', dataType);
    this.liapiservice.disableTryItBtn(btnId);
    this.liapiservice.geoAPIsTryApiBatchLikeGetCall(methodName, tmpData).pipe(
      finalize(() => {
        this.liapiservice.enableTryItBtn(btnId);
        this.post_addrUsCanUri = requestUri;
        this.post_addrUsCanResType = dataType;
        this.post_addrUsCanBody = this.liapiservice.getFormattedResponse(dataType, requestAddress);
        if(this.post_addrUsCanResStatus.includes('429')){
          this.post_addrUsCanUri = '';
          this.liapiservice.showPrimeInfo();
        }
      }
    )).subscribe(
      success => {
        this.post_addrUsCanResStatus = '200 success';
        this.post_addrUsCanRes = this.liapiservice.getFormattedResponse(dataType, success);
      },
      error => {
        if (error.status && error.statusText) {
          this.post_addrUsCanResStatus = `${error.status} ${error.statusText}`;
          this.post_addrUsCanRes = this.liapiservice.getFormattedResponse(dataType, error.error);
        }
      }
    );
  };
  public post_cityStateUri = "";
  public post_cityStateBody = null;
  public post_cityStateRes = null;
  public post_cityStateResStatus = "";
  public post_cityStateResType = "";
  tryApiGetCityStateProvince = function (btnId) {
    var postalCode = this.postalCodeGetCityStateProvince;
    var dataType = this.dataTypeGetCityStateProvince;
    var performUSProcessing = this.performUSProcessing;
    var performCanadianProcessing = this.performCanadianProcessing;
    var outputVanityCity = this.outputVanityCity;
    var maximumResults = this.maximumResultsGetCityStateProvince;
    var requestAddress;
    if (dataType == 'json') {
      requestAddress = '{"options": {"PerformUSProcessing": "' + performUSProcessing + '","PerformCanadianProcessing":"' + performCanadianProcessing + '","OutputVanityCity":"' + outputVanityCity + '","MaximumResults":"' + maximumResults + '"},' + '"Input": {"Row": [{' + '"PostalCode": "' + postalCode + '"}]}}';
    } else {
      requestAddress = '<GetCityStateProvinceAPIRequest><options><PerformUSProcessing>' + performUSProcessing + '</PerformUSProcessing><PerformCanadianProcessing>' + performCanadianProcessing + '</PerformCanadianProcessing><OutputVanityCity>' + outputVanityCity + '</OutputVanityCity><MaximumResults>' + maximumResults + '</MaximumResults></options><Input><Row><PostalCode>' + postalCode + '</PostalCode></Row></Input></GetCityStateProvinceAPIRequest>';
    }
    var tmpData = {
      dataType: dataType,
      data: requestAddress
    };
    var methodName = '/tryApiGetCityStateProvinceRest';
    let requestUri = this.liapiservice.getCompleteUriPostLikeGet('addressverification', 'GetCityStateProvince', dataType);
    this.liapiservice.disableTryItBtn(btnId);
    this.liapiservice.geoAPIsTryApiBatchLikeGetCall(methodName, tmpData).pipe(
      finalize(() => {
        this.liapiservice.enableTryItBtn(btnId);
        this.post_cityStateUri = requestUri;
        this.post_cityStateResType = dataType;
        this.post_cityStateBody = this.liapiservice.getFormattedResponse(dataType, requestAddress);
        if(this.post_cityStateResStatus.includes('429')){
          this.post_cityStateUri = '';
          this.liapiservice.showPrimeInfo();
        }
      }
    )).subscribe(
      success => {
        this.post_cityStateResStatus = '200 success';
        this.post_cityStateRes = this.liapiservice.getFormattedResponse(dataType, success);
      },
      error => {
        if (error.status && error.statusText) {
          this.post_cityStateResStatus = `${error.status} ${error.statusText}`;
          this.post_cityStateRes = this.liapiservice.getFormattedResponse(dataType, error.error);
        }
      }
    );
  };
  public post_postalUri = "";
  public post_postalBody = null;
  public post_postalRes = null;
  public post_postalResStatus = "";
  public post_postalResType = "";
  tryApiGetPostalCodes = function (btnId) {
    var city = this.cityGetPostalCodes;
    var stateProvince = this.stateProvinceGetPostalCodes;
    var dataType = this.dataTypeGetPostalCodes;
    var outputVanityCity_PostalCodes = this.outputVanityCity_PostalCodes;
    var outputCityType = this.outputCityType;
    var requestAddress;
    if (dataType == 'json') {
      requestAddress = '{"options": {"OutputVanityCity": "' + outputVanityCity_PostalCodes + '","OutputCityType":"' + outputCityType + '"},' + '"Input": {"Row": [{' + '"City": "' + city + '","StateProvince":"' + stateProvince + '"}]}}';
    }
    else {
      requestAddress = '<GetPostalCodesAPIRequest><options><OutputVanityCity>' + outputVanityCity_PostalCodes + '</OutputVanityCity><OutputCityType>' + outputCityType + '</OutputCityType></options><Input><Row><City>' + city + '</City><StateProvince>' + stateProvince + '</StateProvince></Row></Input></GetPostalCodesAPIRequest>';
    }
    var tmpData = {
      dataType: dataType,
      data: requestAddress
    };
    var methodName = '/tryApiGetPostalCodesRest';
    let requestUri = this.liapiservice.getCompleteUriPostLikeGet('addressverification', 'GetPostalCodes', dataType);
    this.liapiservice.disableTryItBtn(btnId);
    this.liapiservice.geoAPIsTryApiBatchLikeGetCall(methodName, tmpData).pipe(
      finalize(() => {
        this.liapiservice.enableTryItBtn(btnId);
        this.post_postalUri = requestUri;
        this.post_postalResType = dataType;
        this.post_postalBody = this.liapiservice.getFormattedResponse(dataType, requestAddress);
        if(this.post_postalResStatus.includes('429')){
          this.post_postalUri = '';
          this.liapiservice.showPrimeInfo();
        }
      }
    )).subscribe(
      success => {
        this.post_postalResStatus = '200 success';
        this.post_postalRes = this.liapiservice.getFormattedResponse(dataType, success);
      },
      error => {
        if (error.status && error.statusText) {
          this.post_postalResStatus = `${error.status} ${error.statusText}`;
          this.post_postalRes = this.liapiservice.getFormattedResponse(dataType, error.error);
        }
      }
    );
  };
}
